import React, {Component} from 'react';

class TextPlaceholder extends Component {
	render() {
		const {size = 100, length = 12, colour = '#ffffff', opacity = 0.4} = this.props;

		return (
			<div
				className="TextPlaceholder"
				style={{
					background: colour,
					display: 'inline-block',
					height: `${(size * 12) / 100}pt`,
					width: `${length * 16}px`,
					opacity: opacity
				}}
			/>
		);
	}
}

export default TextPlaceholder;



// WEBPACK FOOTER //
// ./src/widgets/TextPlaceholder.js